// Vendai V-Pay (PERSONAL) — sabitler ve enum eşlemeleri.
// Kaynak: VendaiDigitalPaySwagger.txt + demo-ui.html + yükleme şablonları.

// --- Para ---------------------------------------------------------------
// Tutarlar kuruş. Doğrulandı: BakiyeYüklemeŞablonu'nun sütun başlığı
// "Bakiye(Kuruş)" ve demo tam sayı gönderiyor.

/** 1234 -> "12,34 TL", 24000 -> "240 TL", 0 -> "0 TL" (tam sayıda ondalık gösterilmez) */
export function formatKurus(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "";
  return (
    (n / 100).toLocaleString("tr-TR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }) + " TL"
  );
}

/** "12,34" | "12.34" | "1.000,00" | "1.000 TL" | "12,34 TL" | 12.34 -> kuruş (API'ye giden değer) */
export function parseKurus(input) {
  if (input === null || input === undefined || input === "") return 0;
  let s = String(input).replace(/[^\d.,]/g, ""); // "TL", ₺, boşluk vs. temizle
  if (!s) return 0;
  if (s.includes(",")) {
    // tr-TR: virgül ondalık, nokta binlik ayıracı
    s = s.replace(/\./g, "").replace(",", ".");
  } else {
    // Virgül yok: 3 hane süren noktalar binlik ayıracı (1.000 / 1.000.000);
    // sona yakın 1-2 haneli nokta ondalık kabul edilir (12.34).
    // ponytail: kuruş en fazla 2 ondalık olduğu için 3 hane = binlik varsayımı güvenli.
    s = s.replace(/\.(?=\d{3}(?:\.|$))/g, "");
  }
  const n = Number(s);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100);
}

// --- Enum'lar -----------------------------------------------------------
// Swagger enum'ları isimsiz (sadece sayı). İsimler demo-ui.html'deki
// select option'larından alındı.

// BalanceTypeEnum [0, 332, 333] — demo: 333 = Standart, 332 = İSG.
export const BALANCE_STANDARD = 333;
export const BALANCE_ISG = 332;
export const BALANCE_TYPES = [
  { value: BALANCE_STANDARD, label: "Standart" },
  { value: BALANCE_ISG, label: "İSG" },
];

// BalanceLoadTypeEnum [1, 4] — demo: devreden bakiye davranışı.
export const BALANCE_LOAD_TYPES = [
  { value: 1, label: "Devirli Bakiye Yükleme" },
  { value: 4, label: "Devirsiz Bakiye Yükleme" },
];

// Backend TransactionTypeEnum.
export const TRANSACTION_TYPE = Object.freeze({
  NONE: 0,
  LOAD_ROLLOVER_BALANCE: 1,
  PAYMENT: 2,
  REFUND: 3,
  LOAD_NO_ROLLOVER_BALANCE: 4,
});

export const TRANSACTION_TYPES = [
  { value: TRANSACTION_TYPE.NONE, label: "Belirsiz" },
  { value: TRANSACTION_TYPE.LOAD_ROLLOVER_BALANCE, label: "Devirli Bakiye Yükleme" },
  { value: TRANSACTION_TYPE.PAYMENT, label: "Ödeme" },
  { value: TRANSACTION_TYPE.REFUND, label: "İade" },
  { value: TRANSACTION_TYPE.LOAD_NO_ROLLOVER_BALANCE, label: "Devirsiz Bakiye Yükleme" },
];

export const transactionTypeLabel = (value) =>
  TRANSACTION_TYPES.find((type) => type.value === Number(value))?.label ??
  `Bilinmeyen (${value})`;

export const balanceTypeLabel = (value) => {
  const balanceType = Number(value);
  if (balanceType === BALANCE_ISG) return "İSG";
  if (balanceType === BALANCE_STANDARD) return "Standart";
  if (balanceType === 0) return "Belirsiz";
  return `Bilinmeyen (${value})`;
};

// VendAppPayResultStatusEnum
export const PAY_RESULT_SUCCESS = 2002;
export const PAY_RESULT_FAILURE = -2002;

// NOT: LettaResult zarfını (returnCode/exMessage/data) axiosInterceptor açıyor —
// returnCode === 0 ise `data` döner, değilse exMessage ile Error fırlatır.

// --- Demo görsel dili ---------------------------------------------------
// demo-ui.html :root değişkenleri.
export const DP_FONT_FAMILY =
  '"Segoe UI Variable", "Segoe UI", Inter, "Helvetica Neue", Arial, sans-serif';

export const DP = {
  bg: "#f6f7fb",
  surface: "#ffffff",
  sidebar: "#0b1020",
  sidebarHover: "rgba(255,255,255,.08)",
  sidebarText: "#a8b3cf",
  sidebarActive: "#ffffff",
  primary: "#0b74de",
  primaryDark: "#075bb5",
  primarySoft: "#eaf4ff",
  success: "#10b981",
  danger: "#ef4444",
  warning: "#f59e0b",
  textMain: "#172033",
  textMuted: "#64748b",
  border: "#e5e9f2",
  radius: "14px",
  shadowSm: "0 1px 3px rgba(15,23,42,.05), 0 8px 24px rgba(15,23,42,.04)",
  shadowMd: "0 16px 40px rgba(15,23,42,.10)",
};

export const SIDEBAR_WIDTH = 272;

// Düşük bakiye eşiği (Kart İzleme ekranındaki "Düşük Bakiye" filtresi).
// ponytail: sabit eşik; backend limit tanımından türetmek isterse buradan alınır.
export const LOW_BALANCE_KURUS = 10000; // 100,00 ₺
